export const UPDATE_MERGING_SEARCH_TERM = 'merging/UPDATE_SEARCH_TERM'
export const UPDATE_MERGING_MERGE_TICKET = 'merging/UPDATE_MERGE_TICKET'
export const CHANGE_MERGE_DIRECTION = 'merging/CHANGE_MERGE_DIRECTION'
export const RESET_TO_DEFAULTS = 'merging/RESET_TO_DEFAULTS'

export const MERGE_SEARCH = 'merging/MERGE_SEARCH'
export const MERGE_SEARCH_STARTED = 'merging/MERGE_SEARCH_STARTED'
export const MERGE_SEARCH_FAILED = 'merging/MERGE_SEARCH_FAILED'
export const MERGE_SEARCH_SUCCESS = 'merging/MERGE_SEARCH_SUCCESS'
